export const DEFAULT_BASE_URL = process.env.REACT_APP_DEFAULT_URL
export const DEFAULT_BASE_URL_V2 = process.env.REACT_APP_DEFAULT_URL_V2
export const DEFAULT_BASE_URL_DEV_V2 = process.env.REACT_APP_DEFAULT_URL_SIT
export const FR_HEADER = process.env.REACT_APP_FR_HEADER
export const FR_SYSTEM_CONFIG = process.env.REACT_APP_FR_SYSTEM_CONFIG
export const FR_SYSTEM_CONFIG_MBAL_APP = process.env.REACT_APP_FR_SYSTEM_CONFIG_MBAL_APP
export const TO_HEADER = process.env.REACT_APP_TO_HEADER
export const SITE_KEY_CAPTCHA_GOOGLE= process.env.REACT_APP_SITE_KEY_CAPTCHA_GOOGLE
export const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL

export const PATH_INQUIRY_POLICY= process.env.REACT_APP_PATH_INQUIRY_POLICY
export const PATH_CHANNEL= process.env.REACT_APP_PATH_CHANNEL
export const PATH_TOKEN_CARD= process.env.REACT_APP_PATH_TOKEN_CARD
export const PATH_TOKEN_CARD_DELETE= process.env.REACT_APP_PATH_TOKEN_CARD_DELETE
export const PATH_INIT_PAYMENT= process.env.REACT_APP_PATH_INIT_PAYMENT
export const PATH_INQUIRY_BILL= process.env.REACT_APP_PATH_INQUIRY_BILL
export const PATH_CREATE_DATA_INIT_PAYMENT= process.env.REACT_APP_PATH_CREATE_DATA_INIT_PAYMENT
export const PATH_UPDATE_STATUS_PAY= process.env.REACT_APP_PATH_UPDATE_STATUS_PAY
export const PATH_CREATE_DATA_INIT_PAYMENT_V2= process.env.REACT_APP_PATH_CREATE_DATA_INIT_PAYMENT_V2
export const PATH_CHARGE_PAYER= process.env.REACT_APP_PATH_CHARGE_PAYER
export const PATH_INQUIRY_REQUEST_ITEM = process.env.REACT_APP_PATH_INQUIRY_REQUEST_ITEM
export const PATH_GET_ORDER_DETAIL = process.env.REACT_APP_PATH_GET_ORDER_DETAIL
export const BANK_ACCOUNT = process.env.REACT_APP_BANK_ACCOUNT
export const BANK_NAME = process.env.REACT_APP_BANK_NAME

